import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { Button } from 'client/components/Button/Button'
import LearnWorlds from 'images/learn_worlds.svg'
import Podia from 'images/podia.svg'
import Skillshare from 'images/skillshare.svg'
import Teachable from 'images/teachable.svg'
import Udemy from 'images/udemy.svg'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const ALTERNATIVES = [Udemy, Skillshare, Podia, LearnWorlds, Teachable]

const MainBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.HomePage)
  return (
    <div className="flex w-full flex-col items-center gap-16 pt-30 text-center">
      <div className="flex flex-col items-center gap-2 whitespace-pre-wrap">
        <Text tagName="h2" className="font-title---120px text-palette-white uppercase">
          {t('main_block.title')}
        </Text>
        <Text tagName="p" className="font-body---24px text-palette-grey--50">
          {t('main_block.caption')}
        </Text>
      </div>
      <div className="flex flex-col items-center gap-4">
        <Text tagName="span" className="font-body---24px text-palette-grey--50">
          {t('main_block.alternative')}
        </Text>
        <div className="flex items-center gap-3">
          {ALTERNATIVES.map((item, index) => (
            <img src={item} key={index} className="h-32" />
          ))}
        </div>
      </div>
      <div className="flex w-full justify-center">
        <Button className="font-body---28px h-20 px-14">{t('main_block.button')}</Button>
      </div>
      <div className="flex w-full flex-col items-center gap-4">
        <div className="flex items-center gap-8">
          <Text tagName="span" className="font-title---120px text-palette-white">
            $ 8,804,586
          </Text>
          <div className="relative">
            <div
              className="h-10 w-10 rounded-half"
              style={{
                background: 'rgba(92, 49, 244, 0.5)',
                backdropFilter: 'blur(2px)',
              }}
            />
            <div className="absolute left-2 top-2 h-6 w-6 rounded-half bg-palette-purple" />
          </div>
        </div>
        <Text tagName="span" className="font-body---24px text-palette-grey--50">
          {t('main_block.creators')}
        </Text>
      </div>
      <div className="flex flex-col items-center gap-2">
        <Text tagName="h2" className="font-title---120px uppercase text-palette-white">
          {t('main_block.idea.title')}
        </Text>
        <Text tagName="p" className="font-body---24px text-palette-grey--50">
          &gt;{`${t('main_block.idea.caption')}`}
        </Text>
      </div>
    </div>
  )
}

export { MainBlock }
